var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWhiteHeart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 22,
    viewBox: "0 0 25 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "heart"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path4",
    d: "M16.17 3.77002C14.64 3.79002 13.24 4.63002 12.5 5.97002C11.76 4.63002 10.36 3.79002 8.83 3.77002C6.34 3.88002 4.4 5.98002 4.49 8.47002C4.49 11.85 8.46 15.59 11.26 17.8C11.99 18.37 13.01 18.37 13.73 17.8C16.53 15.59 20.5 11.86 20.5 8.47002C20.6 5.98002 18.66 3.88002 16.17 3.77002Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteHeart);
export default __webpack_public_path__ + "static/media/white-heart.137dca078eacf483ba433eafbe6fcc82.svg";
export { ForwardRef as ReactComponent };